import _typeof from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Project from 'src/store/models/Project';
import Group from 'src/store/models/Group';
import User from 'src/store/models/User';
import Client from 'src/store/models/Client';
import ExpenseCategory from 'src/store/models/ExpenseCategory';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: {
    options: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    customOptions: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(value) {
        var validConfirmationTitle = !value.confirmationDialogTitle || typeof value.confirmationDialogTitle === 'string';
        var validConfirmationMessage = !value.confirmationDialogMessage || typeof value.confirmationDialogMessage === 'string';
        return validConfirmationTitle && validConfirmationMessage && Array.isArray(value) && value.every(function (item) {
          return _typeof(item) === 'object' && item.name !== undefined;
        });
      }
    },
    search: {
      type: Boolean,
      default: true
    },
    nullable: {
      type: Boolean,
      default: false
    },
    emitValue: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    valueKey: {
      type: String,
      default: null
    },
    entityType: {
      type: String,
      default: null
    },
    excludedEntityType: {
      type: String,
      default: ''
    },
    excludedEntityId: {
      type: Number,
      default: null
    }
  },
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    var typeName = this.entityType.replace(' ', '_').replace('-', '_');
    return {
      typeName: typeName,
      pagination: {
        rowsPerPage: 0
      },
      filter: '',
      columns: [{
        name: 'name',
        label: this.entityType && this.entityType !== 'billable-status' ? this.$t('components.pickers.type_name', {
          el: this.$tc("general.".concat(typeName), 1)
        }) : '',
        align: 'left',
        sortable: false
      }],
      selected: []
    };
  },
  computed: {
    customOptionExists: function customOptionExists() {
      var _this = this;

      return this.customOptions.find(function (option) {
        return option[_this.rowKey] === _this.selectedOptionsValue;
      });
    },
    selectedCustomOption: function selectedCustomOption() {
      return this.customOptionExists && this.selected.length > 0 ? this.selected[0] : null;
    },
    isValueSelected: function isValueSelected() {
      if (this.multiple) {
        return this.selectedOptionsValue.length;
      } else {
        return this.selectedOptionsValue !== null || this.selectedCustomOption;
      }
    },
    internalOptions: function internalOptions() {
      var _this2 = this;

      if (this.options) return this.options;
      var options = this.customOptions.map(function (option) {
        var _option$color, _option$iconName;

        option.custom = true;
        option.color = (_option$color = option.color) !== null && _option$color !== void 0 ? _option$color : 'gray';
        option.iconName = (_option$iconName = option.iconName) !== null && _option$iconName !== void 0 ? _option$iconName : 'iconeye:remove-circle-1';
        return option;
      });
      var results = [];

      switch (this.entityType) {
        case 'user':
          results = User.query().with('avatar').whereHasNot(this.excludedEntityType + 's', function (query) {
            query.where(_this2.excludedEntityType + '_id', _this2.excludedEntityId);
          }).where(function (user) {
            return user.name.toLowerCase().includes(_this2.filter.toLowerCase());
          }).where('enabled', 1).orderBy('name', 'asc').get();
          break;

        case 'client':
          results = Client.query().whereHasNot(this.excludedEntityType + 's', function (query) {
            query.where(_this2.excludedEntityType + '_id', _this2.excludedEntityId);
          }).where(function (client) {
            return client.name.toLowerCase().includes(_this2.filter.toLowerCase());
          }).orderBy('name', 'asc').get();
          break;

        case 'project':
          results = Project.query().whereHasNot(this.excludedEntityType + 's', function (query) {
            query.where(_this2.excludedEntityType + '_id', _this2.excludedEntityId);
          }).where(function (project) {
            return project.name.toLowerCase().includes(_this2.filter.toLowerCase());
          }).where('is_active', 1).where('is_public', 0).orderBy('name', 'asc').get();
          break;

        case 'expense-category':
          results = ExpenseCategory.query().where(function (category) {
            return category.name.toLowerCase().includes(_this2.filter.toLowerCase());
          }).where('is_active', 1).where('uses_unit_price', 0).orderBy('name', 'asc').get();
          break;

        case 'group':
          results = Group.query().whereHasNot(this.excludedEntityType + 's', function (query) {
            query.where(_this2.excludedEntityType + '_id', _this2.excludedEntityId);
          }).where(function (group) {
            return group.name.toLowerCase().includes(_this2.filter.toLowerCase());
          }).orderBy('name', 'asc').get();
          break;

        default:
          results = [];
          break;
      }

      return options.concat(results);
    },
    selectedOptionsValue: function selectedOptionsValue() {
      var _this3 = this;

      if (this.multiple) {
        return this.selected.map(function (entity) {
          if (_this3.emitValue) {
            return entity[_this3.rowKey];
          } else {
            entity.new = true;
            return entity;
          }
        });
      } else {
        return this.emitValue ? this.selected[0] && this.selected[0][this.rowKey] ? this.selected[0][this.rowKey] : null : this.selected[0];
      }
    },
    rowKey: function rowKey() {
      switch (this.entityType) {
        case 'access level':
          return 'value';

        case 'billable-status':
          return 'value';

        case 'expense-category':
          return 'expense_category_id';

        default:
          return this.entityType ? this.entityType + '_id' : 'value';
      }
    }
  },
  methods: {
    onRowClick: function onRowClick(e, row) {
      row.selected = !row.selected;
    },
    getConfirmationTitle: function getConfirmationTitle() {
      if (this.selectedCustomOption && this.selectedCustomOption.confirmationDialogTitle) {
        return this.selectedCustomOption.confirmationDialogTitle;
      }

      return this.confirmationDialogTitle;
    },
    getConfirmationMessage: function getConfirmationMessage() {
      if (this.selectedCustomOption && this.selectedCustomOption.confirmationDialogMessage) {
        return this.selectedCustomOption.confirmationDialogMessage;
      }

      return this.confirmationDialogMessage;
    },
    getTitle: function getTitle() {
      if (this.entityType === 'expense-category') {
        return this.$t('components.pickerDialog.select_expense_category');
      } else {
        if (this.multiple) {
          return this.$t('components.pickers.select_one_or_more_type', {
            el: this.$tc("general.".concat(this.typeName), 2).toLowerCase()
          });
        } else {
          return this.$t('components.pickerDialog.select_element', {
            el: this.$tc("general.".concat(this.typeName), 1).toLowerCase()
          });
        }
      }
    },
    getSearchPlaceholder: function getSearchPlaceholder() {
      if (this.entityType === 'expense-category') {
        return this.$t('general.search_within_expense_categories');
      } else {
        return this.$t('components.pickers.search_within', {
          el: this.$tc("general.".concat(this.typeName), 2).toLowerCase()
        });
      }
    },
    save: function save() {
      var _this4 = this;

      this.showLoading();
      this.onComplete(this.selectedOptionsValue).then(function () {
        _this4.hide();
      }).catch(function () {}).finally(function () {
        _this4.saving = false;

        _this4.hideLoading();
      });
    },
    updateSelected: function updateSelected(selectedRow, isSelected) {
      var _this5 = this;

      if (selectedRow.custom && isSelected) {
        // If custom option is selected, remove all other selected options
        this.selected = this.selected.filter(function (option) {
          return option[_this5.rowKey] === selectedRow[_this5.rowKey];
        });
      } else if (isSelected && !selectedRow.custom) {
        // Remove selected custom option if it exists
        this.selected = this.selected.filter(function (option) {
          return !option.custom;
        });
      }
    }
  }
};